/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCarveOutRequest
 */
export interface UpdateCarveOutRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCarveOutRequest
     */
    medication_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarveOutRequest
     */
    dosage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarveOutRequest
     */
    route?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarveOutRequest
     */
    frequency?: string;
    /**
     * Pass null to clear a previously set cost.
     * @type {number}
     * @memberof UpdateCarveOutRequest
     */
    cost_per_day?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarveOutRequest
     */
    j_code?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarveOutRequest
     */
    ndc?: string;
    /**
     * Pass null to clear a previously set stop date.
     * @type {string}
     * @memberof UpdateCarveOutRequest
     */
    stop_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarveOutRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateCarveOutRequest interface.
 */
export function instanceOfUpdateCarveOutRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateCarveOutRequestFromJSON(json: any): UpdateCarveOutRequest {
    return UpdateCarveOutRequestFromJSONTyped(json, false);
}

export function UpdateCarveOutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCarveOutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'medication_name': !exists(json, 'medication_name') ? undefined : json['medication_name'],
        'dosage': !exists(json, 'dosage') ? undefined : json['dosage'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'frequency': !exists(json, 'frequency') ? undefined : json['frequency'],
        'cost_per_day': !exists(json, 'cost_per_day') ? undefined : json['cost_per_day'],
        'j_code': !exists(json, 'j_code') ? undefined : json['j_code'],
        'ndc': !exists(json, 'ndc') ? undefined : json['ndc'],
        'stop_date': !exists(json, 'stop_date') ? undefined : json['stop_date'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function UpdateCarveOutRequestToJSON(value?: UpdateCarveOutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'medication_name': value.medication_name,
        'dosage': value.dosage,
        'route': value.route,
        'frequency': value.frequency,
        'cost_per_day': value.cost_per_day,
        'j_code': value.j_code,
        'ndc': value.ndc,
        'stop_date': value.stop_date,
        'notes': value.notes,
    };
}

